import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useGenreColumns } from "@/pages/genres/hooks/use-columns";
import { IGenreData } from "@/types/genre";

export const GenresList = () => {
  const defaultQueryBy = "transliterations.el,name";

  const columns = useGenreColumns();

  const table = useTable<IGenreData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: {
        right: ["actions"],
      },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: defaultQueryBy,
      },
      sorters: {
        initial: [
          {
            field: "name",
            order: "asc",
          },
        ],
      },
      pagination: {
        pageSize: 25,
      },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="genres" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
